import { variables } from '@styles';

import { PERSONALIZATION_TOKEN_TAG } from '@utils/personalization';

/**
 SampleTemplate component variables
 @returns {variables}
 */

export const DEFAULT_HIGHLIGHTED_ELEMS = [
  {
    id: '',
    event: null,
  },
];

export const IFRAME_BOTTOM_OFFSET = 24; // in px

export const HIGHLIGHTED_ELEM_BORDER_WIDTH = '2';

export const MODULE_CONTENT_DIV_ID = 'module-content';

export const MODULE_DIV_CONTAINER_ID = 'pilotlaunchai-module';

export const MODULE_INTERACTION_STYLES_ID = 'module-interaction-styles';
export const MODULE_INTERACTION_IFRAME_BODY_ID = 'pilotlaunchai-module-iframe';
export const MODULE_INTERACTION_ACTIVE_ATTRIBUTE = 'active';
export const MODULE_INTERACTION_DRAG_ATTRIBUTE = 'draggable';
export const MODULE_INTERACTION_HOVER_ATTRIBUTE = 'hovered';
export const MODULE_INTERACTION_HOVER_ID = 'pilotlaunchai-module-hover';
export const MODULE_INTERACTION_ACTIVE_ID = 'pilotlaunchai-module-active';
// extra space needed for active/hover overlays to appear below content in modules at bottom
export const MODULE_INTERACTION_ACTIVE_HEIGHT = 20; // in px
export const MODULE_INTERACTION_STYLES = `
  html {
    overflow: hidden; 
    border-radius: 20px;
  }

  body {
    border-radius: 20px;
  }

  ${PERSONALIZATION_TOKEN_TAG} {
    background-color: ${variables.colorV2.personalizationToken.background};
    border-radius: 3rem;
    color: ${variables.colorV2.personalizationToken.text};
    padding: 0 10px;
    pointer-events: none;
  }
  pre[contenteditable="true"]:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }
  [active="true"] {
    position: relative;
  }
  [hovered="true"] {
    position: relative;
  }
  #${MODULE_INTERACTION_HOVER_ID} {
    border-color: ${variables.colorV2.contentModule.border.hover};
    border-style: solid;
    border-width: 0 0 2px 0; 
    box-sizing: content-box;
    display: none;
    pointer-events: none;
    position: absolute;
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_HOVER_ID}::after {
    border-color: transparent transparent ${variables.colorV2.contentModule.border.hover} transparent;
    border-style: solid;
    border-width: 10px;
    bottom: -10px;
    content: "";
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_ACTIVE_ID} {
    border-color: ${variables.colorV2.contentModule.border.active};
    border-style: solid;
    border-width: 0 0 2px 0; 
    box-sizing: content-box;
    display: none;
    pointer-events: none;
    position: absolute;
    z-index: 2000000;
  }
  #${MODULE_INTERACTION_ACTIVE_ID}::after {
    border-color: transparent transparent ${variables.colorV2.contentModule.border.active} transparent;
    border-style: solid;
    border-width: 10px;
    bottom: -10px;
    content: "";
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    z-index: 2000000;
  }

  #${MODULE_INTERACTION_HOVER_ID}::after, 
  #${MODULE_INTERACTION_ACTIVE_ID}::after {
    bottom: -10px;
    content: "";
    left: 50%;
    position: absolute;
    right: initial;
    transform: translateX(-50%);
  }

  img, h1, h2, h3, h4, h5, h6, strong, span, p, button, a, div {
    cursor: pointer;
}
`;

export const MODULE_ELEMENT_ID_PREFIX = 'pilotlaunchai-module-elem-';

export const EDITABLE_ELEMENT_TAG_NAMES = [
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'span',
  'p',
  'button',
  'a',
  'div',
];

export const ORIGINAL_ID_ATTRIBUTE = 'data-original-id';
